interface FooterStackItem {
  label: string;
  url: string;
  icon?: string;
}

interface FooterStack {
  heading: string;
  id: string;
  items: FooterStackItem[];
}

export const mainFooterStacks: FooterStack[] = [
  {
    heading: 'Personal Loans',
    id: 'footerPersonalLoans',
    items: [
      {
        label: 'All Personal Loans',
        url: 'https://www.bestegg.com/personal-loans/',
      },
      {
        label: 'Debt Consolidation',
        url: 'https://www.bestegg.com/personal-loans/debt-consolidation-loan/',
      },
      {
        label: 'Credit Card Refinancing',
        url: 'https://www.bestegg.com/personal-loans/credit-card-refinancing-loan/',
      },
      {
        label: 'Home Improvements',
        url: 'https://www.bestegg.com/personal-loans/home-improvement-loan/',
      },
      {
        label: 'Moving Expenses',
        url: 'https://www.bestegg.com/personal-loans/moving-expenses-loan/',
      },
      {
        label: 'Major Purchases',
        url: 'https://www.bestegg.com/personal-loans/other-major-purchases-loan/',
      },
      {
        label: 'Baby & Adoption',
        url: 'https://www.bestegg.com/personal-loans/baby-and-adoption-loan/',
      },
      {
        label: 'Special Occasion',
        url: 'https://www.bestegg.com/personal-loans/special-occasions-loan/',
      },
    ],
  },
  {
    heading: 'Company',
    id: 'footerCompany',
    items: [
      {
        label: 'About',
        url: 'https://www.bestegg.com/about/',
      },
      {
        label: 'Careers',
        url: 'https://www.bestegg.com/careers/',
      },
      {
        label: 'News & Press',
        url: 'https://www.bestegg.com/press/',
      },
      {
        label: 'COVID-19 Updates',
        url: 'https://www.bestegg.com/coronavirus-updates-resources/',
      },
      {
        label: 'Lending Partners',
        url: 'https://www.bestegg.com/lending-partners/',
      },
    ],
  },
  {
    heading: 'Legal',
    id: 'footerLegal',
    items: [
      {
        label: 'Privacy Policies',
        url: 'https://www.bestegg.com/privacy-center/privacy-policy/',
      },
      {
        label: 'California Privacy Notice',
        url: 'https://www.bestegg.com/privacy-center/ccpa-privacy-notice/',
      },
      {
        label: 'Request Card Member Agreement',
        url: 'https://www.bestegg.com/apply/request-cardmember-agreement',
      },
      {
        label: 'Terms of Use',
        url: 'https://www.bestegg.com/terms-of-use/',
      },
      {
        label: 'Licenses',
        url: 'https://www.bestegg.com/licenses/',
      },
      {
        label: 'Accessibility',
        url: 'https://www.bestegg.com/accessibility/',
      },
    ],
  },
  {
    heading: 'Support',
    id: 'footerSupport',
    items: [
      {
        label: 'Help Center',
        url: 'https://support.bestegg.com/hc/en-us',
      },
      {
        label: 'Contact',
        url: 'https://www.bestegg.com/contact-us/',
      },
      {
        label: 'Payment Mailing Address',
        url: 'https://support.bestegg.com/hc/en-us/articles/4410581820059-How-do-I-make-payments-Personal-Loans',
      },
    ],
  },
];

export const column1ExtendedItems: FooterStackItem[] = [
  {
    label: 'Credit Card',
    url: 'https://www.bestegg.com/credit-card/',
  },
  {
    label: 'Financial Health Tools',
    url: 'https://www.bestegg.com/financial-health/',
  },
  {
    label: 'Resources',
    url: 'https://www.bestegg.com/resources/',
  },
];

export const pressFooterStack: FooterStack = {
  heading: 'Social',
  id: 'footerSocialMedia',
  items: [
    {
      icon: 'fa fa-facebook-f',
      label: 'Visit us on Facebook',
      url: 'https://www.facebook.com/mybestegg/',
    },
    {
      icon: 'fa fa-twitter',
      label: 'Visit us on Twitter',
      url: 'https://twitter.com/mybestegg',
    },
    {
      icon: 'fa fa-instagram',
      label: 'Visit us on Instagram',
      url: 'https://www.instagram.com/mybestegg/',
    },
    {
      icon: 'fa fa-linkedin',
      label: 'Visit us on LinkedIn',
      url: 'https://www.linkedin.com/company/bestegg',
    },
    {
      icon: 'fa fa-youtube',
      label: 'Visit us on YouTube',
      url: 'https://www.youtube.com/c/BestEggPlatform',
    },
    {
      icon: 'fa fa-tiktok',
      label: 'Visit us on TikTok',
      url: 'https://www.tiktok.com/@mybestegg',
    },
  ],
};
